import { render, staticRenderFns } from "./userIcon.vue?vue&type=template&id=58b000df&scoped=true&"
import script from "./userIcon.vue?vue&type=script&lang=js&"
export * from "./userIcon.vue?vue&type=script&lang=js&"
import style0 from "./userIcon.vue?vue&type=style&index=0&id=58b000df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b000df",
  null
  
)

component.options.__file = "userIcon.vue"
export default component.exports